import { useCallback } from "react";
import toast from "react-hot-toast";
import { useConfiguration } from "../../useConfiguration";
import { useAPIUtils } from "../../useAPIUtils";
import { CUSTOMER_APIS } from "@/api_framework/api_config";
export const useVaccinationOCRAPI = () => {
  const configuration = useConfiguration();
  const { captureError, toastNotification } = useAPIUtils();
  const execute = useCallback(
    async (files: FileList | File[], user_id: string, petId: string) => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        if (!accessToken) {
          toast.error("Authentication error. Please log in again.");
          return { status: false, message: "Missing access token" };
        }
        const formData = new FormData();
        const fileArray = Array.isArray(files) ? files : Array.from(files);
        // :point_down: Append multiple files using the SAME key: "file"
        fileArray.forEach((file) => {
          formData.append("file", file);
        });
        const url = `${CUSTOMER_APIS?.VACCINATION_OCR?.baseURL}?user_id=${user_id}&pet_id=${petId}`;

        const response = await fetch(url, {
          method: "POST",
          headers: {
            Authorization: `${accessToken}`, // :white_check_mark: Add Bearer prefix
            // :x: DO NOT set 'Content-Type' — let browser set it automatically with correct boundary
          },
          body: formData,
        });
        
        if (response.ok) {
          const result = await response.json();
          toastNotification(result?.message || "Upload successful");
          return { status: true, message: result?.data || "Success" };
        } else {
          
          const statusCode = response.status;
          if (statusCode === 413) {
            toast.error("File size is too large. Please compress and try again");
            return { status: false, message: "File size is too large" };
          }
          const errorJson = await response.json().catch(() => ({}));

          if (statusCode >= 500) {
            toast.error("Server error. Please try again later.");
            return { status: false, message: errorJson?.message};
          }
          
          toast.error(errorJson?.message);
          return { status: false, message: errorJson?.message };
        }
      } catch (error: any) {
        captureError(error);
        console.log("Fetch error object:", error);

        if (error.name === "AbortError") {
          toast.error("Request timed out. Please try again.");
          return { status: false, message: "Timeout error" };
        }

        if (error instanceof TypeError && error.message === "Failed to fetch") {
          toast.error("Network error: Could not connect to server.");
          return { status: false, message: "Network error" };
        }

        toast.error("Unexpected error occurred.");
        return { status: false, message: "Unexpected error occurred." };
      }
    },
    [configuration, captureError, toastNotification],
  );
  return { execute };
};
